import { FC } from 'react';
import Header from '../../../components/Header/Header';
import TableCard from '../../../components/Tables/TableCard/TableCard';
import { showToast } from '../../../components/Toast/Toast';
import { ToastTypes } from '../../../components/Toast/Toast.types';
import { useUsers } from '../../../services/user/user.service';
import { User, UserRoles, UserTypes } from '../../../types/auth.types';
import styles from './Users.module.css';
import { useTranslation } from 'react-i18next';

const Users: FC = () => {
  const { t } = useTranslation();
  const { data, isLoading, isError } = useUsers(true);

  if (isError) {
    showToast({
      label: t('error.fetchingUsers'),
      toastType: ToastTypes.Error,
      id: 'errorFetchingUsers',
    });
  }

  return (
    <>
      <Header title={t('userManagement.title')} breadcrumb={{ label: t('breadcrumb.backToHome'), to: '/' }} />
      <div className={styles.pageContainer}>
        <TableCard
          width="100%"
          data={data?.data || []}
          isLoading={isLoading}
          returnedRecordsText={(count) => t('userManagement.table.returnedRecord', { count })}
          enableFilters
          columns={[
            {
              header: t('userManagement.table.user'),
              enableSorting: true,
              accessorFn: (row: User) =>
                row.firstName || row.lastName ? `${row.firstName || ''} ${row.lastName || ''}` : '-',
            },

            {
              header: t('userManagement.table.email'),
              accessorFn: (row: User) => row.email || '-',
            },

            {
              header: t('userManagement.table.type'),
              accessorFn: (row: User) => (row.type === UserTypes.ADMIN ? 'Admin' : 'Franchisee'),
            },

            {
              header: t('userManagement.table.role'),
              accessorFn: (row: User) => (row.role === UserRoles.VIEW ? 'View Only' : 'Edit'),
            },

            {
              header: t('userManagement.table.organization'),
              accessorFn: (row: User) => row.fzCode || '-',
            },
          ]}
        />
      </div>
    </>
  );
};

export default Users;
